import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IToast, LiveMessage } from './interfaces'
import { VerifyResponse } from '../../components/success/SuccessStage'
import { AppThunk } from '../rootReducer'

export const initialState = {
  baseUrl: '',
  programId: -1,
  toasts: [] as IToast[],
  successfulResponse: {} as VerifyResponse,
  loadedViaCode: false,
  loadedViaFamilyToken: false,
  isRestoredData: false,
  liveMessages: [] as LiveMessage[],
  acknowledgedLiveMessages: [] as string[],
}

const misc = createSlice({
  name: 'process',
  initialState,
  reducers: {
    setData(state, action) {
      state.baseUrl = action.payload.baseUrl
      state.programId = action.payload.programId
    },
    setLiveMessages(state, action: PayloadAction<LiveMessage[]>) {
      state.liveMessages = action.payload
    },
    acknowledgeLiveMessage(state, action: PayloadAction<string>) {
      if (!state.acknowledgedLiveMessages.includes(action.payload)) {
        state.acknowledgedLiveMessages.push(action.payload)
      }
    },
    addToast(state, action: PayloadAction<IToast>) {
      if(state.toasts.find((t) => t.body === action.payload.body)) {
        console.log("Already have a toast with the same text visible, skipping!")
      }else {
        state.toasts.push(action.payload)
      }
    },
    removeToast(state, action: PayloadAction<number>) {
      state.toasts.splice(action.payload, 1)
    },
    clearToasts(state) {
      state.toasts = []
    },
    setSuccessfulResponse(state, action) {
      state.successfulResponse = action.payload
    },
    setLoadedViaCode(state, action: PayloadAction<boolean>) {
      state.loadedViaCode = action.payload
    },
    setLoadedViaFamilyToken(state, action: PayloadAction<boolean>) {
      state.loadedViaFamilyToken = action.payload
    },
  },
})

export const {
  setData,
  addToast,
  removeToast,
  clearToasts,
  setSuccessfulResponse,
  setLoadedViaCode,
  setLoadedViaFamilyToken,
  setLiveMessages,
  acknowledgeLiveMessage,
} = misc.actions

export const fetchLiveMessages = (): AppThunk => async (dispatch, getState) => {
  try {
    const { baseUrl } = getState().misc
    const response = await fetch(`${baseUrl}/api/custom/live-messages/`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      //@ts-ignore
      credentials: window._is_react_dev_server ? 'include' : 'same-origin',
    })
    if (!response.ok) {
      console.warn('Failed to fetch live messages:', response.statusText)
      return
    }
    const data = await response.json()
    const messages: LiveMessage[] = Array.isArray(data?.messages) ? data.messages : []
    dispatch(setLiveMessages(messages))
  } catch (e) {
    console.warn('Error fetching live messages', e)
  }
}

export default misc.reducer
